import { getStore } from '../store/store';

export function isEmailRemindersPickerStoreInitialized(viewStateId: string | null): boolean {
    const isEmailRemindersPickerStoreAvailableForId = getStore().viewStates.has(viewStateId);
    return !!isEmailRemindersPickerStoreAvailableForId;
}
